export { default } from './EmprestimoGarantiaCarroContratoComoFez';
